import React from 'react';
import ReactModal from 'react-modal';

import ModalCommonOrderContent from './ModalCommonOrderContent';

const ModalCommonOrder = ({
  isOpen,
  explanation,
  cashBoxName,
  cashBoxId,
  type,
  onTransactionBatchSubmit,
  closeModalTransactionBatch,
  disabledButton
}) => {
  return (
    <ReactModal
      isOpen={isOpen}
      contentLabel="Modal"
      className="modal-container overflow-modal"
      overlayClassName="modal-overlay">
      <ModalCommonOrderContent
        explanation={explanation}
        cashBoxName={cashBoxName}
        cashBoxId={cashBoxId}
        type={type}
        onTransactionBatchSubmit={onTransactionBatchSubmit}
        closeModalTransactionBatch={closeModalTransactionBatch}
        disabledButton={disabledButton}
      />
    </ReactModal>
  );
};

export default ModalCommonOrder;
